/** Exact public sources for Glide-owned static assets that still had Cloudinary URLs in code. */
export interface OwnedStaticAsset {
    readonly sourceURL: string;
    readonly transformation?: string;
}

const assets: ReadonlyMap<string, OwnedStaticAsset> = new Map([
    [
        "image/fetch/f_auto,w_500,c_limit/https%3A%2F%2Fstorage.googleapis.com%2Fglide-prod.appspot.com%2Fuploads-v2%2F5zWTcmyq5cnVt6YqpVeJ%2Fpub%2FPfOfMFwQNgmWxB8yAj6n.png",
        {
            sourceURL:
                "https://storage.googleapis.com/glide-prod.appspot.com/uploads-v2/5zWTcmyq5cnVt6YqpVeJ/pub/PfOfMFwQNgmWxB8yAj6n.png",
            transformation: "w-500,c-at_max",
        },
    ],
    [
        "image/fetch/f_auto,w_500,c_limit/https%3A%2F%2Fstorage.googleapis.com%2Fglide-prod.appspot.com%2Fuploads-v2%2F5zWTcmyq5cnVt6YqpVeJ%2Fpub%2FdNeuEmW3IdSypNOONEun.png",
        {
            sourceURL:
                "https://storage.googleapis.com/glide-prod.appspot.com/uploads-v2/5zWTcmyq5cnVt6YqpVeJ/pub/dNeuEmW3IdSypNOONEun.png",
            transformation: "w-500,c-at_max",
        },
    ],
    [
        "image/fetch/f_auto,w_500,c_limit/https%3A%2F%2Fstorage.googleapis.com%2Fglide-prod.appspot.com%2Fuploads-v2%2F5zWTcmyq5cnVt6YqpVeJ%2Fpub%2Fv2vzgLvf1d0PKBLibkXt.png",
        {
            sourceURL:
                "https://storage.googleapis.com/glide-prod.appspot.com/uploads-v2/5zWTcmyq5cnVt6YqpVeJ/pub/v2vzgLvf1d0PKBLibkXt.png",
            transformation: "w-500,c-at_max",
        },
    ],
    [
        "image/upload/f_auto,w_500,c_limit/v1752695803/glidehq/Workflows.jpg",
        {
            sourceURL:
                "https://storage.googleapis.com/glideapps-dotcom/preserved-cloudinary/static-assets/0769657f23517b529d888c9faf41b3bb16ba2b14833169943814c6b54b0c06e1/175679301a4885f51f7e6ebd258ece09.png",
        },
    ],
    [
        "image/upload/v1572388650/glidehq/glide-pin.png",
        {
            sourceURL:
                "https://storage.googleapis.com/glideapps-dotcom/preserved-cloudinary/static-assets/1d36b30d94b7ccaf76b64c39e2832a405dfe45494b5cd54d9ef437ffe1db66e2/1e464fc5d15388121ef26c83605cb7db.png",
        },
    ],
    [
        "image/upload/v1684851461/growth/web-embed.png",
        {
            sourceURL:
                "https://storage.googleapis.com/glideapps-dotcom/preserved-cloudinary/static-assets/0110abb9a078edf9a435391d6404d3246798bd5a38fe82474c956f874df018d8/9bd2efb10d327d47ddfe8407eacfe6b3.png",
        },
    ],
    [
        "image/upload/v1684851831/growth/big-query.png",
        {
            sourceURL:
                "https://storage.googleapis.com/glideapps-dotcom/preserved-cloudinary/static-assets/055de463c5f8c6073cb446f4c4cc3c18d8a5fe4e696f1838ff67d7d4af54b55f/24787f9c569fee3a9e5beb0599684a36.png",
        },
    ],
    [
        "image/upload/v1684859162/growth/barcode-scanner.jpg",
        {
            sourceURL:
                "https://storage.googleapis.com/glideapps-dotcom/preserved-cloudinary/static-assets/1da5ee97bd7ae77cd78cb522d1ae7a81f28d2fb9c5bf452702aa5924c06ea5e7/27826546f72b65c1b01db261b305eb51.jpg",
        },
    ],
    [
        "image/upload/v1761122591/glidehq/data-restore-illustration.png",
        {
            sourceURL:
                "https://storage.googleapis.com/glideapps-dotcom/preserved-cloudinary/static-assets/1ce07daabf160e8a2b2cdc3e251af342d3e64a8551b49ef62184fc9756516e84/cd8c4e95347e58ca01bf5b86bc1e7368.png",
        },
    ],
    [
        "video/upload/v1684848901/growth/big-tables-video.mp4",
        {
            sourceURL:
                "https://storage.googleapis.com/glideapps-dotcom/preserved-cloudinary/static-assets/99c5dec68d1fcb0d27d7fdf2381803b4a0509c7884f73ed3c357e60720982942/2f56575a8f9a06214cf002c24936a268.mp4",
        },
    ],
    [
        "video/upload/v1694097810/growth/glide-ai-video.mp4",
        {
            sourceURL:
                "https://storage.googleapis.com/glideapps-dotcom/preserved-cloudinary/static-assets/e4a4e2ca7a12feb08fb1279d00ea863eaa411f3c4d65b43baf68540c90ba3b23/f3efc5837550ba090459be4ce984c758.mp4",
        },
    ],
]);

export function ownedStaticAsset(path: string): OwnedStaticAsset | undefined {
    return assets.get(path);
}

export function ownedStaticAssetPaths(): readonly string[] {
    return [...assets.keys()];
}
